import {ConfigurationApplication} from '@application/Config';

export const getClientId = (): string => ConfigurationApplication.retrieve().googleWebId;
